var _defs, _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _ellipse, _path4, _path5, _g9, _path6, _path7, _g0, _g1, _path8, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationBee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 160,
    viewBox: "0 0 120 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.416,
    cy: 0.667,
    r: 0.632,
    gradientTransform: "matrix(1.132, -0.114, 0.129, 0.994, 1.548, -1.282)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#e6e4e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#91a0ad"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.47,
    cy: 0.684,
    r: 0.692,
    gradientTransform: "matrix(0.962, -0.113, 0.11, 0.994, 0.229, -0.226)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.683,
    cy: -0.097,
    r: 0.94,
    gradientTransform: "matrix(0.92, 0.276, -0.264, 0.961, 0.261, -3.028)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#334157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.185,
    cy: -0.019,
    r: 0.854,
    gradientTransform: "matrix(-1.098, 0.417, 0.504, 0.909, 53.499, -10.588)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 5.472,
    y1: 1.33,
    x2: 6.404,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b49780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#bba08a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#d6c1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e9d9c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f4e7d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9edde"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.674,
    y1: 2.461,
    x2: 1.592,
    y2: 3.032,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#040200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.624,
    y1: 2.774,
    x2: 1.639,
    y2: 2.774,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f1e08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6a04e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.712,
    cy: -0.35,
    r: 1.127,
    gradientTransform: "matrix(-0.371, 0.479, 0.213, 0.923, 101.048, -35.469)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#987e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#301d15"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.454,
    cy: 0.52,
    r: 1.173,
    gradientTransform: "matrix(-0.312, 0.102, 0.033, 1.031, 150.715, -9.623)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.405,
    cy: 0.6,
    r: 0.466,
    gradientTransform: "matrix(0.854, -0.645, -0.708, -0.75, -12.835, -50.965)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.354,
    cy: 0.596,
    r: 0.481,
    gradientTransform: "matrix(0.915, -0.611, -0.62, -0.693, -17.542, -74.458)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.485,
    y1: -1.633,
    x2: 0.529,
    y2: -1.633,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 9.016,
    y1: -6.723,
    x2: 9.972,
    y2: -6.723,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 7.422,
    y1: -2.351,
    x2: 8.34,
    y2: -1.779,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.276,
    cy: 0.323,
    r: 0.723,
    gradientTransform: "matrix(1.058, 0.046, -0.049, 0.999, -0.025, -0.035)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f5bf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#efac00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#eea600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.26,
    cy: 0.239,
    r: 0.744,
    gradientTransform: "matrix(0.536, 0.046, -0.025, 0.999, 0.368, -0.035)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#987e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c3123"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 1.362,
    cy: 1.24,
    r: 0.798,
    gradientTransform: "translate(0.255) scale(0.49 1)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 3.712,
    cy: 2.421,
    r: 0.728,
    gradientTransform: "translate(0.224) scale(0.552 1)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.501,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "translate(0.274 -0.575) rotate(14.42)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.508,
    cy: 0.5,
    r: 0.368,
    gradientTransform: "matrix(1.936, 0.874, -3.486, 0.486, -43.14, -80.794)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 0.631,
    cy: 0.492,
    r: 0.366,
    gradientTransform: "matrix(1.908, 0.874, -3.435, 0.486, -114.377, -219.088)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.214,
    cy: 0.051,
    r: 1.052,
    gradientTransform: "matrix(0.493, -0.096, 0.036, 0.754, 5.517, -0.516)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 0.598,
    cy: 0.487,
    r: 0.954,
    gradientTransform: "matrix(0.413, -0.096, 0.03, 0.754, 11.641, -1.362)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.578,
    cy: 0.497,
    r: 0.374,
    gradientTransform: "translate(0.013) scale(0.977 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#987e77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#927870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#73594e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5d4336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#503528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c3123"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 0.484,
    cy: 0.331,
    r: 0.622,
    gradientTransform: "matrix(1.171, -0.122, 0.16, 1.103, 0.386, -0.178)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ffd854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#ca9a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd854"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.383,
    cy: 0.508,
    r: 0.465,
    gradientTransform: "matrix(-1.08, 0, 0, 1.081, 56.537, -0.004)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5983c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5a648"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 0.544,
    cy: 0.498,
    r: 0.428,
    gradientTransform: "matrix(-1.165, 0, 0, 1.17, 33.583, 0.385)",
    xlinkHref: "#radial-gradient-20"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 0.494,
    cy: 0.416,
    r: 0.495,
    gradientTransform: "matrix(-0.847, 0.202, 0.194, 1.088, 10.741, -1.081)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18871",
    "data-name": "Path 18871",
    d: "M500.652,311.955c-1.552-2.231-2.481-10.1,2.57-12.908,4.119-2.29,8.174.326,9.015,4.4a7.869,7.869,0,0,1-3.169,7.923c-3.141,2.161-7.5,1.909-8.416.588Z",
    transform: "translate(-499.422 -298.195)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 0.463,
    cy: 0.723,
    r: 0.567,
    gradientTransform: "matrix(-1.003, 0, 0, 1, 52.793, 0.004)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#6ecef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#297fa0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f394a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18879",
    "data-name": "Path 18879",
    d: "M343.814,327.007c.617-3.024-1.957-11.641-8.5-12.292-5.337-.53-8.4,4.022-7.444,8.644a8.931,8.931,0,0,0,6.883,6.828c4.257.836,8.7-1.389,9.063-3.18Z",
    transform: "translate(-327.694 -314.672)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 0.525,
    cy: 0.725,
    r: 0.568,
    gradientTransform: "translate(0.72 0.147) rotate(-10.5)",
    xlinkHref: "#radial-gradient-24"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 0.462,
    cy: 0.221,
    r: 0.559,
    gradientTransform: "matrix(-0.81, 0.093, 0.076, 0.996, 157.145, -8.066)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 0.462,
    cy: 0.508,
    r: 0.375,
    gradientTransform: "matrix(-2.897, 0.093, 0.27, 0.996, 2035.729, -48.505)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 0.487,
    cy: 0.501,
    r: 0.476,
    gradientTransform: "matrix(-1.077, 0.093, 0.101, 0.996, 264.89, -11.844)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 0.515,
    cy: 0.511,
    r: 0.392,
    gradientTransform: "matrix(-2.133, 0.093, 0.199, 0.996, 1209.42, -35.848)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 0.522,
    cy: 0.514,
    r: 0.39,
    gradientTransform: "matrix(-2.233, 0.093, 0.208, 0.996, 1549.269, -44.496)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 0.496,
    cy: 0.459,
    r: 0.803,
    gradientTransform: "matrix(-0.493, 0.093, 0.046, 0.996, 145.067, -9.035)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 0.368,
    cy: 0.227,
    r: 3.451,
    gradientTransform: "matrix(0.214, -0.468, -0.209, -1.63, -42.744, -216.875)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c5983c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5a648"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 0.739,
    cy: -0.089,
    r: 1.11,
    gradientTransform: "matrix(0.478, 0.031, -0.016, 1.104, 0.131, -1.734)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 0.505,
    cy: 0.492,
    r: 0.746,
    gradientTransform: "matrix(0.537, 0.054, -0.029, 0.999, -3.971, 0.521)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 0.745,
    cy: -0.178,
    r: 1.23,
    gradientTransform: "matrix(0.416, 0.034, -0.015, 1.039, 1.291, -0.204)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 0.506,
    cy: 0.495,
    r: 0.848,
    gradientTransform: "matrix(0.459, 0.054, -0.025, 0.999, -3.813, 0.426)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 0.505,
    cy: 0.51,
    r: 0.486,
    gradientTransform: "matrix(1.078, -0.043, 0.046, 0.999, 0.133, -0.03)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 0.662,
    cy: -0.158,
    r: 1.172,
    gradientTransform: "matrix(0.436, 0.054, -0.025, 1.066, 1.862, -0.027)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 0.506,
    cy: 0.485,
    r: 0.839,
    gradientTransform: "matrix(0.463, 0.054, -0.025, 0.999, -3.642, 0.41)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 0.503,
    cy: 0.513,
    r: 0.658,
    gradientTransform: "matrix(0.64, -0.043, 0.028, 0.999, -0.262, -0.044)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 0.518,
    cy: 0.509,
    r: 0.42,
    gradientTransform: "matrix(1.582, -0.043, 0.068, 0.999, 1.066, -0.07)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 0.206,
    cy: 0.61,
    r: 0.565,
    gradientTransform: "matrix(-2.077, 0, 0, 1, 492.989, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 0.5,
    cy: 0.5,
    r: 0.373,
    gradientTransform: "matrix(-2.986, 0, 0, 1, 834.646, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 0.5,
    cy: 0.5,
    r: 0.362,
    gradientTransform: "matrix(-4.518, 0, 0, 1, 2000.855, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 0.5,
    cy: 0.5,
    r: 0.393,
    gradientTransform: "matrix(-2.047, 0, 0, 1, 376.72, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 0.5,
    cy: 0.5,
    r: 0.388,
    gradientTransform: "matrix(-2.226, 0, 0, 1, 456.863, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 0.5,
    cy: 0.5,
    r: 0.381,
    gradientTransform: "matrix(-2.509, 0, 0, 1, 674.676, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 0.5,
    cy: 0.5,
    r: 0.359,
    gradientTransform: "matrix(-5.575, 0, 0, 1, 3794.385, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 0.499,
    cy: 0.5,
    r: 0.361,
    gradientTransform: "matrix(-4.817, 0, 0, 1, 4580.381, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: -0.197,
    cy: 0.406,
    r: 0.619,
    gradientTransform: "matrix(-2.077, 0, 0, 1, 511.249, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 0.501,
    cy: 0.5,
    r: 0.357,
    gradientTransform: "matrix(-7.2, 0, 0, 1, 10001.758, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 0.5,
    cy: 0.5,
    r: 0.373,
    gradientTransform: "matrix(-2.986, 0, 0, 1, 864.069, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 0.5,
    cy: 0.5,
    r: 0.362,
    gradientTransform: "matrix(-4.517, 0, 0, 1, 2062.397, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 0.5,
    cy: 0.5,
    r: 0.359,
    gradientTransform: "matrix(-5.734, 0, 0, 1, 4145.427, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 0.5,
    cy: 0.5,
    r: 0.393,
    gradientTransform: "matrix(-2.047, 0, 0, 1, 388.47, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 0.5,
    cy: 0.5,
    r: 0.388,
    gradientTransform: "matrix(-2.227, 0, 0, 1, 470.308, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 0.5,
    cy: 0.5,
    r: 0.384,
    gradientTransform: "matrix(-2.343, 0, 0, 1, 626.87, 0)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Confirmation_Bee"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 160
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Confirmation_Bee",
    "data-name": "Confirmation Bee",
    clipPath: "url(#clip-Confirmation_Bee)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset_2",
    "data-name": "Asset 2",
    transform: "translate(1.246 2.282)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(0.004 0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8877",
    "data-name": "Group 8877"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18846",
    "data-name": "Path 18846",
    d: "M240.045,59.939c-2.458-3.372-4.944-7.018-7.4-10.945q-2.217-3.538-4.149-6.947a3.982,3.982,0,0,1-1.025,2.022A2.622,2.622,0,0,1,225.5,45.1a2.041,2.041,0,0,1-1.877-1.614c-.019-1.291,2.77-3.12,5.026-2.758,3.051.489,3.684,4.746,7.04,9.938A34.439,34.439,0,0,0,244.735,60c-.817,1.258-4.069,1.132-4.688-.058Z",
    transform: "translate(-197.205 -35.873)",
    fill: "url(#radial-gradient-3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18847",
    "data-name": "Path 18847",
    d: "M456.537,20.9c1.923-3.7,3.834-7.68,5.677-11.933q1.66-3.831,3.058-7.491a4,4,0,0,0,1.317,1.846,2.623,2.623,0,0,0,2.1.719,2.04,2.04,0,0,0,1.614-1.877C470.131.89,467.1-.5,464.923.2c-2.944.941-2.931,5.246-5.468,10.882a34.427,34.427,0,0,1-7.545,10.588c1,1.121,4.193.508,4.627-.761Z",
    transform: "translate(-398.529 -0.011)",
    fill: "url(#radial-gradient-4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18848",
    "data-name": "Path 18848",
    d: "M592.25,569.725c-9.762-5.967-37.139-14.521-45.563-10.06l-2.867,4.3c.369,1.733.9,6.535,3.991,8.571a9.278,9.278,0,0,0,6.625,5.265s3.487,4.518,7.737,4.072c0,0,8.585,3.346,12.039-.892,0,0,12.019,3.785,17.49-1.416,0,0,11.215-3.324.548-9.843Z",
    transform: "translate(-479.582 -492.462)",
    opacity: 0.5,
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8833",
    "data-name": "Group 8833",
    transform: "translate(64.238 65.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18849",
    "data-name": "Path 18849",
    d: "M579.71,564.084c-11.931-4.283-27.124-7.542-33.023-4.418l-2.867,4.3c.369,1.733.9,6.535,3.991,8.571a9.278,9.278,0,0,0,6.625,5.265,12.663,12.663,0,0,0,4.785,3.643C563.755,579.486,575.912,573.479,579.71,564.084Z",
    transform: "translate(-543.82 -558.425)",
    opacity: 0.3,
    fill: "url(#linear-gradient-2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8834",
    "data-name": "Group 8834",
    transform: "translate(63.992 65.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18850",
    "data-name": "Path 18850",
    d: "M595.223,573.8c.242-1.845-1.335-3.821-4.688-5.87-6.843-4.183-22.059-9.523-33.595-10.951l-.046-.019,0,.012c-5.14-.632-9.546-.485-12.146.891l-.051.027-2.953,4.431.02.094c.043.2.088.443.138.718.395,2.132,1.126,6.089,3.893,7.958a9.782,9.782,0,0,0,3.417,3.968,9.285,9.285,0,0,0,3.264,1.354c.474.591,3.769,4.486,7.834,4.1.789.3,8.679,3.155,12.149-.861,1.456.436,12.274,3.454,17.531-1.477.56-.174,4.875-1.6,5.237-4.374Zm-4.928-5.476a12.3,12.3,0,0,1,3.883,3.327,46.387,46.387,0,0,1-12.974-2.383,8.526,8.526,0,0,1,7.036-2.106c.748.393,1.435.782,2.054,1.16Zm-4.68,11.634a61.168,61.168,0,0,1-7.219-3.643c-.016-.048-.033-.1-.051-.144a19.517,19.517,0,0,1,8.5,3.393,11.78,11.78,0,0,1-1.234.395Zm-21.753-8.278a47.928,47.928,0,0,1,5.471-.539q.679.459,1.362.912c1.836,1.217,3.684,2.4,5.5,3.49a17.6,17.6,0,0,0-6.446,1.021C568.258,575.218,566.245,573.49,563.863,571.678Zm-6.066,3.355a26.046,26.046,0,0,1,9.044,6.259,20.459,20.459,0,0,1-6.332-1.2A50.958,50.958,0,0,0,557.8,575.033Zm-.392-.641a60.74,60.74,0,0,0-8.522-10.875c6.782,2.568,13.153,7.151,17.519,10.762a5.487,5.487,0,0,0-3.038,3.338A25.549,25.549,0,0,0,557.4,574.391Zm9.4-10.568a14.466,14.466,0,0,1-2.57,3.212c-2.661-1.9-5.134-3.736-7.226-5.323a94.96,94.96,0,0,1,9.795,2.111Zm10.174,3.5a28.352,28.352,0,0,1-5.007-6.557,102.448,102.448,0,0,1,15.167,5.834,9.179,9.179,0,0,0-6.412,2.49,24.482,24.482,0,0,1-3.748-1.768Zm-.268.377c1.468,1.494,3.05,2.919,4.592,4.208a31.439,31.439,0,0,0-5.8-1.079,49.752,49.752,0,0,0-4.681-5.757,33.445,33.445,0,0,1,5.875,2.62l.013.007Zm-1.039-1.093a46.3,46.3,0,0,0-8.181-3.065,7.025,7.025,0,0,0,.746-3.84q1.566.418,3.127.881A25.506,25.506,0,0,0,575.669,566.6Zm-5.8-1.858a51.4,51.4,0,0,1,5.012,6.024,45.6,45.6,0,0,0-5.416-.1c-1.647-1.113-3.271-2.243-4.835-3.356a14.446,14.446,0,0,0,2.645-3.363c.861.243,1.731.507,2.593.79Zm-8.452,5.141a22.312,22.312,0,0,0,2.874-2.247c1.428,1.017,2.907,2.049,4.41,3.071a45.629,45.629,0,0,0-5.342.587C562.733,570.831,562.086,570.358,561.416,569.887Zm2.475-2.531a22.172,22.172,0,0,1-2.883,2.245q-.838-.583-1.717-1.159c-1.988-4.961-8.953-9.892-10.885-11.189.6-.085,1.232-.142,1.9-.175C550.931,557.586,556.717,562.228,563.891,567.356Zm6.221,3.756a44.032,44.032,0,0,1,5.1.147,24.81,24.81,0,0,1,2.425,4.366c-.165-.016-.332-.032-.5-.044-2.306-1.371-4.687-2.9-7.034-4.471Zm8.054,4.573a23.642,23.642,0,0,0-2.336-4.366,29.3,29.3,0,0,1,6.418,1.367c3.1,2.515,5.883,4.414,6.989,5.148l.247.163a8.463,8.463,0,0,1-2.132,1.355,19.932,19.932,0,0,0-9.184-3.665Zm-.027-7.214a39.235,39.235,0,0,0,12.411,3.352,7.511,7.511,0,0,0-3.107,4.221,83.844,83.844,0,0,1-9.3-7.574Zm-10.384-8.9a6.51,6.51,0,0,1-.735,3.836c-1.31-.363-2.593-.68-3.793-.955-.279-2.189-3.164-3.964-4.947-4.861a89.03,89.03,0,0,1,9.474,1.98Zm-11.03-2.184c.057.022,5.473,2.189,6.023,4.959-3.421-.761-6.063-1.153-6.509-1.217-2.528-1.927-4.4-3.411-5.233-4.075a40.92,40.92,0,0,1,5.72.33v0Zm-8.989-.024c.782.508,8.369,5.552,10.843,10.621a51.408,51.408,0,0,0-10.5-5.247c-.5-.477-1.012-.947-1.539-1.413a13.69,13.69,0,0,0-1.708-2.823l.172-.259A9.866,9.866,0,0,1,547.735,557.365Zm-2.284,6.525c.5.685,1.043,1.449,1.6,2.266a10.279,10.279,0,0,1-1.15,4.447,6.993,6.993,0,0,1-2.083-2.567A6.007,6.007,0,0,1,545.451,563.89Zm-.634-1.637q.884.213,1.765.479a10.484,10.484,0,0,1,.464,2.586C546.22,564.132,545.443,563.078,544.817,562.253Zm-.437-.572c-.425-.553-.741-.948-.9-1.146l.491-.737q1.136.877,2.191,1.8c.087.2.165.4.239.6q-1.008-.3-2.021-.52Zm.185-2.772a13.815,13.815,0,0,1,1.077,1.644c-.462-.386-.932-.766-1.415-1.139l.338-.507Zm-1.352,2.029c.113.142.273.346.47.6-.259-.05-.518-.1-.777-.138l.307-.461Zm3.7,1.338.13.12-.1-.032c-.009-.029-.02-.06-.031-.09Zm-4.568.777c-.044-.238-.084-.451-.121-.636l.4-.6q.742.115,1.485.274c.308.4.669.882,1.064,1.419a6.574,6.574,0,0,0-1.769,3.591,21.768,21.768,0,0,1-1.057-4.051Zm3.884,7.9a10.56,10.56,0,0,0,1.246-4.177c1.971,2.938,4.015,6.4,4.793,9.107a9.149,9.149,0,0,1-6.04-4.932Zm6.575,5.142c-.764-3-3.121-6.924-5.29-10.1a10.817,10.817,0,0,0-.406-3.1q.363.117.725.241a60.742,60.742,0,0,1,12.153,16.933c-3.748.168-6.874-3.59-7.182-3.972Zm14.638,5.18a24.651,24.651,0,0,0-3.678-3.364c.358-1.993,2.468-3.06,3.025-3.309,2.826,2.364,4.738,4.254,5.267,4.786A6.394,6.394,0,0,1,567.444,581.28Zm5.053-2.1c-.189-.194-1.028-1.041-2.373-2.271a17.6,17.6,0,0,1,6.884-.876c.332.2.661.39.99.581a7.228,7.228,0,0,1,.348,3.7,34.55,34.55,0,0,1-5.849-1.135Zm6.309,1.179a7.355,7.355,0,0,0-.216-3.407,63.143,63.143,0,0,0,6.259,3.18A21.4,21.4,0,0,1,578.806,580.364Zm11.091-2.645c-.241-.156-.987-.645-2.056-1.393a7.168,7.168,0,0,1,3.474-4.418c1.607.162,2.756.2,3.135.211a2.789,2.789,0,0,1,.314,1.62c-.314,2.4-4.218,3.767-4.868,3.978Z",
    transform: "translate(-541.74 -556.611)",
    fill: "url(#linear-gradient-3)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8836",
    "data-name": "Group 8836",
    transform: "translate(67.425 67.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18851",
    "data-name": "Path 18851",
    d: "M590.663,577.525c2.972.669,2.212,5.54-.761,4.871l-18.266-6.3a1.484,1.484,0,0,1,1.024-2.775Z",
    transform: "translate(-570.797 -573.27)",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8835",
    "data-name": "Group 8835",
    transform: "translate(7.479 3.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18852",
    "data-name": "Path 18852",
    d: "M634.11,600.47s2.458,1,4.98,1.844c1.257.434,2.53.826,3.5,1.088s1.617.413,1.617.413h.007a.5.5,0,0,0,.608-.405.548.548,0,0,0-.409-.638l-.054-.009s-.645-.075-1.611-.229-2.255-.4-3.538-.692C636.644,601.242,634.11,600.47,634.11,600.47Z",
    transform: "translate(-634.11 -600.47)",
    fill: "url(#radial-gradient-6)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8838",
    "data-name": "Group 8838",
    transform: "translate(73.426 74.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18853",
    "data-name": "Path 18853",
    d: "M626.645,643.813c-2.817,3.4-6.348-.821-4.556-2.819l12.619-12.921c1.146-.811,3.214.344,1.977,1.74l-10.042,14Z",
    transform: "translate(-621.602 -627.804)",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8837",
    "data-name": "Group 8837",
    transform: "translate(3.656 1.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18854",
    "data-name": "Path 18854",
    d: "M662.512,640.6s-2.544,2.574-5.014,5.213c-1.246,1.312-2.464,2.648-3.354,3.673s-1.454,1.733-1.454,1.733l0,.007a.527.527,0,0,0,.127.81.746.746,0,0,0,.927-.195.422.422,0,0,0,.036-.051s.475-.725,1.245-1.8,1.839-2.483,2.944-3.879c2.229-2.781,4.549-5.514,4.549-5.514Z",
    transform: "translate(-652.55 -640.6)",
    fill: "url(#radial-gradient-8)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8841",
    "data-name": "Group 8841",
    transform: "translate(0 66.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8839",
    "data-name": "Group 8839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18855",
    "data-name": "Path 18855",
    d: "M5.221,581.512c5.209,4.979,16.056,2.065,17.516,1.642,3.432,4.049,11.348,1.267,12.14.977,4.061.428,7.393-3.437,7.873-4.023a9.267,9.267,0,0,0,3.276-1.322,9.763,9.763,0,0,0,3.454-3.935c2.785-1.843,3.554-5.793,3.968-7.921.053-.274.1-.516.145-.717l.021-.094L50.7,561.659l-.051-.027c-2.587-1.4-6.991-1.59-12.136-1.006l0-.012-.046.018c-11.549,1.319-26.814,6.516-33.7,10.634C1.4,573.281-.2,575.242.025,577.089c.337,2.776,4.638,4.244,5.2,4.424ZM7.07,570.518a8.527,8.527,0,0,1,7.015,2.172A46.339,46.339,0,0,1,1.09,574.95a12.281,12.281,0,0,1,3.915-3.291c.623-.372,1.315-.754,2.066-1.141Zm1.275,12.413a19.525,19.525,0,0,1,8.535-3.312c-.018.049-.035.1-.052.143a61.472,61.472,0,0,1-7.253,3.574,11.5,11.5,0,0,1-1.23-.406Zm17.133-2.838a17.613,17.613,0,0,0-6.437-1.082c1.821-1.077,3.682-2.24,5.528-3.439q.687-.447,1.37-.9a48.038,48.038,0,0,1,5.466.591c-2.4,1.79-4.428,3.5-5.927,4.828Zm9.2,3.619a20.469,20.469,0,0,1-6.343,1.138,26.047,26.047,0,0,1,9.1-6.173,50.854,50.854,0,0,0-2.759,5.037Zm-2.831-2.5a5.486,5.486,0,0,0-3.006-3.367c4.4-3.57,10.814-8.093,17.619-10.6a60.718,60.718,0,0,0-8.624,10.793,25.588,25.588,0,0,0-5.989,3.169Zm6.507-15.844c-2.107,1.566-4.6,3.378-7.275,5.254a14.453,14.453,0,0,1-2.54-3.236A95.493,95.493,0,0,1,38.355,565.363ZM14.57,572.515a9.179,9.179,0,0,0-6.388-2.552,102.363,102.363,0,0,1,15.222-5.69,28.378,28.378,0,0,1-5.07,6.51,24.592,24.592,0,0,1-3.765,1.733Zm4.042-1.361a33.335,33.335,0,0,1,5.9-2.565,49.747,49.747,0,0,0-4.736,5.712,31.451,31.451,0,0,0-5.809,1.023c1.553-1.275,3.149-2.684,4.63-4.164Zm5.4-7.058q1.561-.448,3.135-.852a7.028,7.028,0,0,0,.71,3.847,46.23,46.23,0,0,0-8.21,2.987A25.476,25.476,0,0,0,24.012,564.1Zm4.054,3.414a14.435,14.435,0,0,0,2.613,3.388c-1.575,1.1-3.208,2.214-4.866,3.311a45.473,45.473,0,0,0-5.416.045,51.377,51.377,0,0,1,5.069-5.977c.865-.275,1.736-.53,2.6-.767Zm3.847,7.379a45.718,45.718,0,0,0-5.336-.638c1.512-1.008,3-2.026,4.438-3.03a22.41,22.41,0,0,0,2.852,2.274q-1.01.7-1.955,1.393ZM45.1,560.794c.665.039,1.3.1,1.9.193-1.944,1.279-8.955,6.144-10.99,11.086q-.884.565-1.728,1.142a22.168,22.168,0,0,1-2.862-2.273C38.64,565.883,44.469,561.3,45.1,560.8ZM18.084,579.042c-.163.009-.328.025-.495.039a24.716,24.716,0,0,1,2.466-4.343,44,44,0,0,1,5.105-.1c-2.361,1.551-4.757,3.053-7.076,4.4Zm-10.24,3.671a8.452,8.452,0,0,1-2.119-1.375l.249-.161c1.113-.723,3.915-2.6,7.038-5.082a29.334,29.334,0,0,1,6.431-1.305,23.6,23.6,0,0,0-2.378,4.344,19.933,19.933,0,0,0-9.22,3.579Zm-.061-3.307a7.513,7.513,0,0,0-3.067-4.25,39.276,39.276,0,0,0,12.442-3.235A83.725,83.725,0,0,1,7.782,579.406Zm29.336-18.175c-1.791.88-4.693,2.628-4.993,4.814-1.2.262-2.488.567-3.8.918a6.515,6.515,0,0,1-.7-3.843,89.062,89.062,0,0,1,9.493-1.89Zm1.557-.194a40.691,40.691,0,0,1,5.722-.275c-.837.656-2.725,2.123-5.272,4.026-.447.059-3.091.426-6.519,1.154.576-2.764,6.013-4.88,6.069-4.9Zm11.706.97.17.26a13.73,13.73,0,0,0-1.735,2.807c-.532.46-1.051.926-1.553,1.4a51.434,51.434,0,0,0-10.544,5.148c2.522-5.045,10.156-10.017,10.943-10.518a9.887,9.887,0,0,1,2.719.905Zm1.1,9.8a7,7,0,0,1-2.106,2.547,10.275,10.275,0,0,1-1.109-4.459c.567-.811,1.117-1.57,1.623-2.25a6.012,6.012,0,0,1,1.592,4.162Zm-3.2-2.75a10.465,10.465,0,0,1,.488-2.581c.588-.173,1.179-.325,1.77-.462C49.9,566.837,49.113,567.884,48.277,569.06Zm.674-3.11c.074-.2.155-.394.243-.6q1.065-.916,2.208-1.785l.484.742c-.159.195-.478.588-.91,1.138Q49.962,565.662,48.951,565.95Zm2.2-2.765c-.487.367-.96.743-1.426,1.126a13.973,13.973,0,0,1,1.093-1.635Zm1.3,2c-.26.04-.519.084-.778.131.2-.252.361-.453.476-.6Zm-4.049.928-.1.031.131-.119-.032.09Zm3.5,4.771a6.574,6.574,0,0,0-1.736-3.607c.4-.534.765-1.008,1.077-1.409q.744-.152,1.487-.26l.393.6c-.039.184-.08.4-.126.635a21.841,21.841,0,0,1-1.1,4.04Zm-8.948,8.7c.8-2.7,2.88-6.144,4.88-9.061a10.583,10.583,0,0,0,1.206,4.187A9.147,9.147,0,0,1,42.953,579.582ZM35.2,583.691a60.762,60.762,0,0,1,12.312-16.817c.242-.081.485-.159.728-.235a10.825,10.825,0,0,0-.436,3.1c-2.2,3.155-4.593,7.056-5.385,10.05-.312.379-3.473,4.107-7.219,3.9ZM23.132,582.9c.534-.528,2.465-2.4,5.312-4.737.555.254,2.654,1.342,2.993,3.337a24.682,24.682,0,0,0-3.71,3.329,6.393,6.393,0,0,1-4.6-1.93Zm-6.3.866a7.237,7.237,0,0,1,.383-3.7q.494-.28,1-.572a17.554,17.554,0,0,1,6.876.943c-1.357,1.219-2.2,2.058-2.394,2.249a34.479,34.479,0,0,1-5.86,1.081Zm-6.5-.245a63.031,63.031,0,0,0,6.29-3.121,7.346,7.346,0,0,0-.249,3.4,21.469,21.469,0,0,1-6.041-.284ZM.481,577.033a2.793,2.793,0,0,1,.33-1.617c.379-.006,1.529-.034,3.136-.182a7.162,7.162,0,0,1,3.432,4.45c-1.076.737-1.827,1.219-2.07,1.373-.646-.217-4.538-1.618-4.829-4.025Z",
    transform: "translate(-0.004 -560.315)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18856",
    "data-name": "Path 18856",
    d: "M6.6,573.051c9.819-5.874,37.274-14.169,45.656-9.627l2.826,4.328c-.384,1.729-.957,6.526-4.072,8.533a9.276,9.276,0,0,1-6.674,5.2s-3.53,4.485-7.775,4c0,0-8.617,3.265-12.03-1.005,0,0-12.055,3.67-17.475-1.582,0,0-11.183-3.429-.456-9.848Z",
    transform: "translate(-1.718 -561.904)",
    opacity: 0.5,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8840",
    "data-name": "Group 8840",
    transform: "translate(17.475 0.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18857",
    "data-name": "Path 18857",
    d: "M147.94,567.523c11.97-4.17,27.194-7.285,33.064-4.1l2.826,4.328c-.384,1.729-.957,6.526-4.072,8.533a9.276,9.276,0,0,1-6.674,5.2,12.649,12.649,0,0,1-4.82,3.6C163.75,583.074,151.649,576.954,147.94,567.523Z",
    transform: "translate(-147.94 -562.112)",
    opacity: 0.3,
    fill: "url(#linear-gradient-6)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8844",
    "data-name": "Group 8844",
    transform: "translate(35.514 83.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18858",
    "data-name": "Path 18858",
    d: "M300.65,753.356c6.734-.193,12.009,1.183,19.312-.1,7.011-1.231,13.091-2.535,19.072-8.978,6.895-7.428,5.763-20.56-.131-28.466-8.392-11.255-20.59-8.318-29.088-2.665-6.823,4.539-10.773,14.759-7.952,23.475,2.729,8.433,3.316,10.167,2.021,12.7a10.968,10.968,0,0,1-3.233,4.038Z",
    transform: "translate(-300.65 -708.139)",
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8842",
    "data-name": "Group 8842",
    transform: "translate(0 8.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18859",
    "data-name": "Path 18859",
    d: "M352.5,793.109c-1.05,7.549-7.569,11.666-15.289,12.645-12.911,1.638-25.386-7.47-26.215-14.743a22.263,22.263,0,0,1,3.757-7.321c.761,4.623,8.816,11.709,22.458,10.476,6.235-.563,9.912-4.585,12.518-9.064a26.268,26.268,0,0,1,2.771,8.005Z",
    transform: "translate(-309.777 -783.69)",
    fill: "url(#radial-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18860",
    "data-name": "Path 18860",
    d: "M345.492,914.347a17.423,17.423,0,0,1-3.988,7.393,25.248,25.248,0,0,1-11.6,7.318c-12.345,2.993-21.8-1.8-23.206-7.155v0c-.4-1.749-1.18-4.148-2.365-7.815a19.1,19.1,0,0,1-.882-4.716c2.82,10.4,14.77,16.008,26.22,14.763,7.135-.776,13.418-3.853,15.823-9.787Z",
    transform: "translate(-303.119 -894.524)",
    fill: "url(#radial-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18861",
    "data-name": "Path 18861",
    d: "M307.789,1063.372c-2.3-.145-4.616-.292-7.139-.22a10.835,10.835,0,0,0,3.071-3.722C303.556,1061.566,305.141,1062.814,307.789,1063.372Z",
    transform: "translate(-300.65 -1026.858)",
    fill: "url(#radial-gradient-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8843",
    "data-name": "Group 8843",
    transform: "translate(4.175 7.057)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_337",
    "data-name": "Ellipse 337",
    cx: 5.548,
    cy: 5.548,
    r: 5.548,
    transform: "translate(0 2.263) rotate(-11.77)",
    opacity: 0.7,
    fill: "url(#radial-gradient-13)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8846",
    "data-name": "Group 8846",
    transform: "translate(21.848 52.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18862",
    "data-name": "Path 18862",
    d: "M188.837,445.882c-.246-2.081-1.621-3.234-2.477-3.069-.716.138-1.344,1.249-1.4,2.639l4.1,24.3c.63,1.038,3.211.152,2.712-1.417l-2.931-22.45Z",
    transform: "translate(-184.96 -442.797)",
    fill: "url(#radial-gradient-14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8845",
    "data-name": "Group 8845",
    transform: "translate(3.318 15.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18863",
    "data-name": "Path 18863",
    d: "M215.6,586.97s-.719-2.344-1.37-4.712c-.335-1.183-.644-2.374-.853-3.277s-.322-1.516-.322-1.516v-.006a.441.441,0,1,1,.867-.159c0,.014,0,.028.006.042s.051.6.17,1.507.308,2.112.527,3.317C215.074,584.573,215.6,586.97,215.6,586.97Z",
    transform: "translate(-213.046 -576.939)",
    fill: "url(#radial-gradient-15)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8848",
    "data-name": "Group 8848",
    transform: "translate(25.883 70.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18864",
    "data-name": "Path 18864",
    d: "M220.637,604.908c-3.14,1.106-.924,4.877,2.216,3.772l16.2-7.406c1.406-.8.256-3.191-1.932-2.431l-16.482,6.066Z",
    transform: "translate(-219.117 -598.695)",
    fill: "url(#radial-gradient-16)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8847",
    "data-name": "Group 8847",
    transform: "translate(3.082 2.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18865",
    "data-name": "Path 18865",
    d: "M256.453,621.6s-2.5,1.276-5.108,2.433c-1.3.588-2.619,1.147-3.629,1.542s-1.7.642-1.7.642l-.007,0a.635.635,0,0,1-.757-.21c-.122-.221.02-.485.317-.591a.464.464,0,0,1,.059-.018s.7-.183,1.731-.493,2.4-.752,3.759-1.232c2.7-.971,5.336-2.075,5.336-2.075Z",
    transform: "translate(-245.211 -621.6)",
    fill: "url(#radial-gradient-17)"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 16.243,
    cy: 15.87,
    rx: 16.243,
    ry: 15.87,
    transform: "translate(41.639 65.103)",
    fill: "url(#radial-gradient-18)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18866",
    "data-name": "Path 18866",
    d: "M279.921,117.795c10.837-2.24,18.692,1.813,23.483,7.623,6.16,7.469,6.947,17.673,6.21,25.745a37.439,37.439,0,0,1-6.476,14.6c-3.02,4.092-6.222,8.431-11.648,9.511-5.584,1.113-10.362-1.852-14.659-4.518a36.545,36.545,0,0,1-10.948-10.56c-3.876-7.119-7.2-16.8-4.5-26.1C263.478,126.868,269.084,120.034,279.921,117.795Z",
    transform: "translate(-229.643 -103.329)",
    fill: "url(#radial-gradient-19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8849",
    "data-name": "Group 8849",
    transform: "translate(55.972 29.748)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_339",
    "data-name": "Ellipse 339",
    cx: 8.179,
    cy: 8.833,
    rx: 8.179,
    ry: 8.833,
    transform: "translate(0 3.312) rotate(-11.68)",
    opacity: 0.9,
    fill: "url(#radial-gradient-20)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8850",
    "data-name": "Group 8850",
    transform: "translate(33.937 30.042)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 9.804,
    cy: 11.423,
    rx: 9.804,
    ry: 11.423,
    transform: "translate(0 3.966) rotate(-11.67)",
    opacity: 0.9,
    fill: "url(#radial-gradient-21)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18867",
    "data-name": "Path 18867",
    d: "M263.533,160.354l.558-.884a34.955,34.955,0,0,1-3.573-14c-.131-3.527-.276-6.81,1.816-10.067a12.668,12.668,0,0,1,6.5-5.368,11.839,11.839,0,0,1,7.229-.124,12.363,12.363,0,0,1,2.477,1.012c.815.535,1.29,1.1,1.91.983a1.387,1.387,0,0,0,.9-.752,10.454,10.454,0,0,1,2.283-2.889,11.051,11.051,0,0,1,6.548-2.638,13.08,13.08,0,0,1,8.093,2.352c5.691,3.6,8.666,12.485,7.879,22.751l1.1.593c.745-8.079-.038-18.283-6.216-25.745-4.807-5.808-12.688-9.853-23.574-7.6a24.656,24.656,0,0,0-13.816,7.545,22.947,22.947,0,0,0-4.814,8.779c-3.756,12.138,3.178,23.65,4.7,26.057Z",
    transform: "translate(-227.292 -103.484)",
    fill: "url(#radial-gradient-22)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8855",
    "data-name": "Group 8855",
    transform: "translate(58.719 34.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18868",
    "data-name": "Path 18868",
    d: "M498.6,302.885c-2.025-3.083-2.678-11.332,2.4-14.095,4.471-2.435,8.851.474,9.53,5.155a8.944,8.944,0,0,1-3.605,8.2c-3.141,2.16-7.439,2.088-8.322.743Z",
    transform: "translate(-497.099 -287.911)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8853",
    "data-name": "Group 8853",
    transform: "translate(0.274 1.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18869",
    "data-name": "Path 18869",
    d: "M500.652,311.955c-1.552-2.231-2.481-10.1,2.57-12.908,4.119-2.29,8.174.326,9.015,4.4a7.869,7.869,0,0,1-3.169,7.923c-3.141,2.161-7.5,1.909-8.416.588Z",
    transform: "translate(-499.422 -298.195)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8852",
    "data-name": "Group 8852",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8851",
    "data-name": "Group 8851",
    transform: "translate(-1.283 2.594)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_341",
    "data-name": "Ellipse 341",
    cx: 5.503,
    cy: 5.52,
    rx: 5.503,
    ry: 5.52,
    transform: "matrix(0.979, -0.203, 0.203, 0.979, 0, 2.23)",
    fill: "url(#radial-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18870",
    "data-name": "Path 18870",
    d: "M510.666,346.976a3.9,3.9,0,1,0,3.029-4.622A3.907,3.907,0,0,0,510.666,346.976Z",
    transform: "translate(-507.982 -339.66)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8854",
    "data-name": "Group 8854",
    transform: "translate(1.449 7.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18872",
    "data-name": "Path 18872",
    d: "M509.381,354.315a.948.948,0,1,0,.736-1.123A.949.949,0,0,0,509.381,354.315Z",
    transform: "translate(-509.361 -353.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18873",
    "data-name": "Path 18873",
    d: "M568.5,386.277a.492.492,0,1,0,.382-.582A.493.493,0,0,0,568.5,386.277Z",
    transform: "translate(-561.507 -381.844)",
    fill: "#fff"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18874",
    "data-name": "Path 18874",
    d: "M334.84,269.7a7.129,7.129,0,0,0-7.37,3.039,5.445,5.445,0,0,1,2.559-2.993A5.617,5.617,0,0,1,334.84,269.7Z",
    transform: "translate(-288.788 -237.374)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18875",
    "data-name": "Path 18875",
    d: "M527.424,263.441a10.889,10.889,0,0,0-2.684-.526,10.515,10.515,0,0,0-5.13.98,26.718,26.718,0,0,1,3.793-.506,27.3,27.3,0,0,1,4.02.051Z",
    transform: "translate(-458.232 -231.841)"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8860",
    "data-name": "Group 8860",
    transform: "translate(38.009 35.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18876",
    "data-name": "Path 18876",
    d: "M338.6,317.216c.726-4.125-2.306-13.015-8.856-13.608-5.772-.523-9.039,4.482-7.642,9.665a10,10,0,0,0,7.4,6.865C333.755,320.975,338.28,319.015,338.6,317.216Z",
    transform: "translate(-321.777 -303.57)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8858",
    "data-name": "Group 8858",
    transform: "translate(0.699 1.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18877",
    "data-name": "Path 18877",
    d: "M343.814,327.007c.617-3.024-1.957-11.641-8.5-12.292-5.337-.53-8.4,4.022-7.444,8.644a8.931,8.931,0,0,0,6.883,6.828c4.257.836,8.7-1.389,9.063-3.18Z",
    transform: "translate(-327.694 -314.672)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8857",
    "data-name": "Group 8857",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8856",
    "data-name": "Group 8856",
    transform: "translate(3.462 2.906)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_342",
    "data-name": "Ellipse 342",
    cx: 6.267,
    cy: 6.267,
    r: 6.267,
    transform: "translate(0 0.258) rotate(-1.18)",
    fill: "url(#radial-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18878",
    "data-name": "Path 18878",
    d: "M382.319,359.33a4.442,4.442,0,1,1-5.249-3.452A4.443,4.443,0,0,1,382.319,359.33Z",
    transform: "translate(-371.574 -353.835)",
    fill: "#231f20"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8859",
    "data-name": "Group 8859",
    transform: "translate(6.074 7.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18880",
    "data-name": "Path 18880",
    d: "M373.222,371.448a1.08,1.08,0,1,0,.839-1.276A1.08,1.08,0,0,0,373.222,371.448Z",
    transform: "translate(-373.2 -370.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18881",
    "data-name": "Path 18881",
    d: "M438.093,408.184a.56.56,0,1,0,.435-.661A.56.56,0,0,0,438.093,408.184Z",
    transform: "translate(-430.417 -403.098)",
    fill: "#fff"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8861",
    "data-name": "Group 8861",
    transform: "translate(63.656 83.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18882",
    "data-name": "Path 18882",
    d: "M552.7,707.6c.814.5,2.341,4.183,1.251,5.406s-5.3,2.4-5.985,2.593a7.726,7.726,0,0,0-1.629,1.345c-.137.2-.721,1.543-1.17,1.822-.353.22-1.184.328-1.29-.814a1.12,1.12,0,0,1-1.81-1.045c-.8.074-1.343-.25-1.227-1.473a7.251,7.251,0,0,1,3.461-5.958,21.614,21.614,0,0,0-2.81.916,6.205,6.205,0,0,0-.807,1.7c-.229.551-.665,1.214-1.207,1.077s-.795-.517-.391-1.52.827-2.485.983-2.811a5.156,5.156,0,0,1,1.909-1.237c.953-.463,2.327-1.089,2.751-1.221a33.094,33.094,0,0,1,4.5.2A8.524,8.524,0,0,1,552.7,707.6Z",
    transform: "translate(-538.888 -706.339)",
    fill: "url(#radial-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18883",
    "data-name": "Path 18883",
    d: "M586.564,714.44c-.137.677-.23,1.357-.32,2.039l0,.031.015.039c.366.913.765,1.81,1.182,2.7.208.445.429.885.653,1.322s.456.872.7,1.3c-.156-.469-.32-.933-.5-1.389s-.359-.915-.553-1.368c-.387-.9-.792-1.8-1.23-2.679l.012.069C586.551,715.817,586.579,715.131,586.564,714.44Z",
    transform: "translate(-580.646 -713.483)",
    fill: "url(#radial-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18884",
    "data-name": "Path 18884",
    d: "M589.944,716.99a2.03,2.03,0,0,1,.464.612,6.39,6.39,0,0,1,.333.695,8.865,8.865,0,0,1,.451,1.466,5.162,5.162,0,0,1,.146,1.486,1.982,1.982,0,0,1-.155.673.986.986,0,0,1-.168.261,1.485,1.485,0,0,1-.121.122l-.128.105a11.089,11.089,0,0,1-2.706,1.316c-.964.355-1.958.635-2.944.932l-.059.018-.04.027a11.467,11.467,0,0,0-1.259.982c-.1.092-.2.184-.3.291a1.437,1.437,0,0,0-.159.2c-.029.046-.08.143-.1.192l-.348.684a5.275,5.275,0,0,1-.38.623,1.238,1.238,0,0,1-.2.221.6.6,0,0,1-.241.111.465.465,0,0,1-.463-.112.742.742,0,0,1-.146-.246,1.823,1.823,0,0,1-.077-.327v.051a4.864,4.864,0,0,1,.1-.565c.046-.19.1-.379.161-.566a8.3,8.3,0,0,1,.449-1.094,6.135,6.135,0,0,1,.627-1.011c.117-.163.249-.311.38-.463s.28-.287.421-.433c-.149.136-.311.258-.45.4a5.393,5.393,0,0,0-.41.444,6.3,6.3,0,0,0-.688.992,6.98,6.98,0,0,0-.821,2.262,1.279,1.279,0,0,0,.259.718.723.723,0,0,0,.7.219.922.922,0,0,0,.356-.145,1.292,1.292,0,0,0,.268-.278,5.543,5.543,0,0,0,.412-.656l.359-.686a1.133,1.133,0,0,1,.217-.319c.089-.094.183-.182.28-.268a11.325,11.325,0,0,1,1.232-.939c1-.278,1.994-.592,2.968-.956.487-.183.969-.38,1.438-.6a6.669,6.669,0,0,0,1.335-.8,1.5,1.5,0,0,0,.472-.608,2.24,2.24,0,0,0,.148-.762,5.391,5.391,0,0,0-.2-1.54,8.466,8.466,0,0,0-.536-1.462,6.375,6.375,0,0,0-.374-.683,2.047,2.047,0,0,0-.511-.581Z",
    transform: "translate(-576.131 -715.732)",
    fill: "url(#radial-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18885",
    "data-name": "Path 18885",
    d: "M556.567,740.291a2.285,2.285,0,0,1-.4-.07.9.9,0,0,1-.372-.194.792.792,0,0,1-.217-.439,1.954,1.954,0,0,1,.008-.64c.037-.226.1-.515.143-.768a10.862,10.862,0,0,1,.441-1.614,7.015,7.015,0,0,1,.322-.777c.126-.246.249-.49.391-.715s.282-.439.431-.635a6.741,6.741,0,0,1,.443-.537c.155-.151.281-.309.41-.434s.235-.242.334-.325c.193-.175.3-.284.3-.284l-.338.228a8.067,8.067,0,0,0-.84.67,6.809,6.809,0,0,0-.5.514,6.566,6.566,0,0,0-.494.63,6.738,6.738,0,0,0-.788,1.548,8.951,8.951,0,0,0-.416,1.688,3.869,3.869,0,0,0-.034,1.507.852.852,0,0,0,.333.492,1.014,1.014,0,0,0,.437.155,1.741,1.741,0,0,0,.406,0Z",
    transform: "translate(-553.386 -729.727)",
    fill: "url(#radial-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18886",
    "data-name": "Path 18886",
    d: "M567.63,759.759a.969.969,0,0,1-.61.145,1.094,1.094,0,0,1-.529-.213,1,1,0,0,1-.186-.2,1.075,1.075,0,0,1-.116-.24,1.089,1.089,0,0,1-.048-.266,2.368,2.368,0,0,1-.011-.276l-.006.057c.053-.216.13-.446.2-.67s.144-.449.226-.669c.152-.445.34-.875.527-1.305l.313-.629c.1-.214.228-.408.349-.613l.2-.288a2.944,2.944,0,0,1,.207-.291c.137-.2.312-.36.469-.556a5.386,5.386,0,0,0-.554.469,5.84,5.84,0,0,0-.489.536c-.142.2-.293.386-.417.6s-.247.417-.364.628a11.342,11.342,0,0,0-.971,2.732,1.964,1.964,0,0,0,.033.333,1.415,1.415,0,0,0,.1.319,1.349,1.349,0,0,0,.179.282,1.276,1.276,0,0,0,.255.215,1.038,1.038,0,0,0,1.243-.1Z",
    transform: "translate(-562.639 -748.15)",
    fill: "url(#radial-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18887",
    "data-name": "Path 18887",
    d: "M544.321,709.486s-.382.082-1.045.239c-.332.081-.734.176-1.2.3-.116.033-.235.066-.358.109a.961.961,0,0,0-.4.209,2.942,2.942,0,0,0-.449.786,5.562,5.562,0,0,1-.83,1.583.706.706,0,0,1-.306.2.285.285,0,0,1-.137,0,.773.773,0,0,1-.175-.06.357.357,0,0,1-.195-.2.815.815,0,0,1,0-.382,2.707,2.707,0,0,1,.149-.469c.069-.175.138-.352.207-.529.134-.357.259-.719.383-1.083s.245-.737.374-1.077a.406.406,0,0,1,.085-.163,1.236,1.236,0,0,1,.16-.143,4.1,4.1,0,0,1,.449-.294c.642-.383,1.347-.716,2.033-1.047l1.025-.475q.253-.11.5-.216l.211-.083a1.178,1.178,0,0,1,.222-.03c.691-.02,1.408.006,2.07.025l1.879.084a12.964,12.964,0,0,1,1.563.158,8.963,8.963,0,0,1,1.181.285,5.573,5.573,0,0,1,.989.4s-.083-.052-.243-.137a5.911,5.911,0,0,0-.721-.322,9.83,9.83,0,0,0-2.751-.577l-1.879-.143c-.667-.04-1.371-.092-2.1-.073a1.325,1.325,0,0,0-.533.129l-.516.215-1.038.468c-.692.326-1.4.65-2.074,1.043a4.387,4.387,0,0,0-.484.325.909.909,0,0,0-.347.455c-.134.364-.248.732-.369,1.1s-.24.724-.369,1.077a7.912,7.912,0,0,0-.358,1.05,1.084,1.084,0,0,0,.013.536.628.628,0,0,0,.363.367.71.71,0,0,0,.505.051.983.983,0,0,0,.413-.285,5.712,5.712,0,0,0,.826-1.682,3.068,3.068,0,0,1,.385-.74,2.028,2.028,0,0,1,.679-.314c.45-.149.847-.265,1.173-.362Z",
    transform: "translate(-538.907 -706.354)",
    fill: "url(#radial-gradient-32)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18888",
    "data-name": "Path 18888",
    d: "M431.44,500.412a41.809,41.809,0,0,1,8.918-3.1,46.739,46.739,0,0,1,8.655-1.106c-.166-.008-.412-.019-.709-.028a33.374,33.374,0,0,0-8.221.717,28.008,28.008,0,0,0-8.643,3.513Z",
    transform: "translate(-380.477 -437.557)",
    fill: "url(#radial-gradient-33)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8862",
    "data-name": "Group 8862",
    transform: "translate(21.939 34.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18889",
    "data-name": "Path 18889",
    d: "M191.958,311.346s3.015,4.41-2.426,5.313c.116.417-3.8-.748-3.8-.748s-.132-9.7,2.3-13.366c.456.024,4.594-2.626,5.868-3.878.945-.982,2.952-2.842,2.952-2.842s2.72-.256,1.664,2.6a9.072,9.072,0,0,1-6.246,4.607c.125-.034,2.614.989,2.614.989a2.551,2.551,0,0,1,1.133-.628,1.92,1.92,0,0,1,1.947,1.669,3.257,3.257,0,0,1-.782,2.873,2.3,2.3,0,0,1-.855.326c-.389.063-.416,1.916-.416,1.916a12.355,12.355,0,0,1-1.683,2.221,3.733,3.733,0,0,0-1.125,1.8,15.428,15.428,0,0,0-1.141-2.852Z",
    transform: "translate(-185.729 -295.633)",
    fill: "#301d15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18890",
    "data-name": "Path 18890",
    d: "M216.382,425.239c-1.511-.321-1.925-3.142-.142-3.149l5.094.29c1.08.033.938,2.626-.389,2.846A13.285,13.285,0,0,1,216.382,425.239Z",
    transform: "translate(-211.602 -406.988)",
    fill: "url(#radial-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18891",
    "data-name": "Path 18891",
    d: "M231.152,424.531l.087.038a.6.6,0,0,1,.1.05c.031.031.064.061.1.09a.815.815,0,0,1,.162.315,1.967,1.967,0,0,1,.032.47,2.466,2.466,0,0,1-.1.547,2.075,2.075,0,0,1-.25.533.933.933,0,0,1-.393.353.285.285,0,0,1-.113.04.715.715,0,0,1-.137.031l-.376.048c-1,.138-2.006.233-2.771.282-.382.019-.706.05-.933.047s-.363.012-.363.012a8.507,8.507,0,0,0,1.282.169,14.742,14.742,0,0,0,2.839-.116,2.448,2.448,0,0,0,.748-.172,1.235,1.235,0,0,0,.521-.52,2.043,2.043,0,0,0,.239-.653,2.216,2.216,0,0,0,.032-.624,1.648,1.648,0,0,0-.125-.511.893.893,0,0,0-.25-.317.531.531,0,0,0-.241-.1l-.091-.017Z",
    transform: "translate(-221.419 -409.139)",
    fill: "url(#radial-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18892",
    "data-name": "Path 18892",
    d: "M209.056,400.62c-2.085,0-2.074-3.441.011-3.44l5.955.348c1.262.043,1.438,3.159-.457,3.132-1.749.079-3.6.056-5.509-.04Z",
    transform: "translate(-204.926 -385.02)",
    fill: "url(#radial-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18893",
    "data-name": "Path 18893",
    d: "M226.655,400.121l.105.041a.747.747,0,0,1,.123.054c.039.034.081.07.128.1a1.082,1.082,0,0,1,.235.371,2.446,2.446,0,0,1,.111.561,2.079,2.079,0,0,1-.058.663,1.688,1.688,0,0,1-.3.608.953.953,0,0,1-.53.317c-.184.022-.561.033-.847.037-.612.028-1.226.04-1.8.072s-1.116.079-1.579.1-.852.085-1.123.105-.428.058-.428.058,2.471.146,4.945.062a8.455,8.455,0,0,0,.919-.06,1.276,1.276,0,0,0,.726-.485,1.785,1.785,0,0,0,.3-.769,2.342,2.342,0,0,0-.007-.745,1.947,1.947,0,0,0-.2-.6,1.192,1.192,0,0,0-.32-.361.661.661,0,0,0-.288-.115l-.109-.021Z",
    transform: "translate(-216.56 -387.613)",
    fill: "url(#radial-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18894",
    "data-name": "Path 18894",
    d: "M200.589,302.5a30.362,30.362,0,0,0,8.85-6.726s2.72-.256,1.664,2.6a9.072,9.072,0,0,1-6.247,4.607c.125-.034,2.614.989,2.614.989a2.551,2.551,0,0,1,1.133-.628,1.92,1.92,0,0,1,1.947,1.669,3,3,0,0,1-.256,2.131c-1.668,2.156-9.893.112-10.308-2.837a2.5,2.5,0,0,1,.6-1.806Z",
    transform: "translate(-198.288 -295.589)",
    fill: "url(#radial-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18895",
    "data-name": "Path 18895",
    d: "M205.508,372.424c-2.153-.044-2.065-3.67.089-3.626,2.126.15,4.184.312,6.144.488,1.3.071,1.414,3.361-.542,3.293A39.233,39.233,0,0,1,205.508,372.424Z",
    transform: "translate(-201.786 -359.99)",
    fill: "url(#radial-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18896",
    "data-name": "Path 18896",
    d: "M223.462,372.93a1.092,1.092,0,0,1,.259.125.79.79,0,0,1,.182.183.734.734,0,0,1,.127.226,1.043,1.043,0,0,1,.078.248,2.565,2.565,0,0,1,.044.258,1.361,1.361,0,0,1,.018.26,1.9,1.9,0,0,1-.054.512,1.561,1.561,0,0,1-.169.462,1.266,1.266,0,0,1-.118.2.773.773,0,0,1-.141.165c-.056.043-.1.1-.163.124s-.111.076-.181.081a.883.883,0,0,1-.2.048l-.214.013H222.9l-2.82.085q-.707.041-1.419.055c-.237.006-.476.031-.715.041s-.477.026-.718.052a39.275,39.275,0,0,0,5.689.155l.286-.021a1.334,1.334,0,0,0,.275-.073.953.953,0,0,0,.253-.132,1.007,1.007,0,0,0,.216-.185,1.115,1.115,0,0,0,.172-.227,1.171,1.171,0,0,0,.129-.255,1.973,1.973,0,0,0,.143-.553,2.194,2.194,0,0,0,.007-.571,2.032,2.032,0,0,0-.13-.555,1.149,1.149,0,0,0-.126-.256.832.832,0,0,0-.176-.223.754.754,0,0,0-.232-.165A1.077,1.077,0,0,0,223.462,372.93Z",
    transform: "translate(-213.509 -363.635)",
    fill: "url(#radial-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18897",
    "data-name": "Path 18897",
    d: "M204.68,301.2s5.829-2.892,8.816-6.665c-.03.006,2.844-.387,1.569,2.761-.021.048.334-.562.334-.562s.931-2.824-1.924-2.463A44.66,44.66,0,0,1,204.68,301.2Z",
    transform: "translate(-202.441 -294.239)",
    fill: "url(#radial-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18898",
    "data-name": "Path 18898",
    d: "M241.08,320.276a9.225,9.225,0,0,0,6.42-4.906s-2.216,4.819-5.916,5l1.96.738a1.86,1.86,0,0,1,2.833.11c0-.046,1.8,1.962-.579,4.313l-.1-.274s1.994-1.06.671-3.784c-.024-.022-.96-1.578-2.7-.172-.425-.148-.866-.311-1.318-.493s-.863-.357-1.264-.539Z",
    transform: "translate(-234.542 -312.874)",
    fill: "url(#radial-gradient-42)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8876",
    "data-name": "Group 8876",
    transform: "translate(39.424 94.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8867",
    "data-name": "Group 8867",
    transform: "translate(24.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8863",
    "data-name": "Group 8863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18899",
    "data-name": "Path 18899",
    d: "M563.592,1145.12c1.8-.475,6.274.948,7.661,6.93,1.273,5.5.8,12.84-1.094,13.132s-4.546-5.629-6.567-10.87C561.839,1149.766,561.8,1145.594,563.592,1145.12Z",
    transform: "translate(-559.535 -1104.273)",
    fill: "url(#radial-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18900",
    "data-name": "Path 18900",
    d: "M579.636,1007.3c-.119.908-1.614,1.562-2.991,1.386-1.4-.177-2.674-1.2-2.554-2.116,1.64-5.828,2.84-12.364,4.28-19.334.137-1.162,3.25-.579,3.113.584-.4,7.289-1.206,13.7-1.849,19.479Z",
    transform: "translate(-569.961 -964.555)",
    fill: "url(#radial-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18901",
    "data-name": "Path 18901",
    d: "M574.15,1011.294s.117-.289.3-.8.451-1.243.712-2.137c.131-.447.273-.931.423-1.444s.307-1.053.435-1.62l.829-3.547c.233-1.217.464-2.435.682-3.575s.354-2.217.505-3.134.222-1.692.3-2.229.092-.849.092-.849l-1.982,9.7c-.509,2.423-1.054,4.839-1.507,6.639S574.15,1011.294,574.15,1011.294Z",
    transform: "translate(-570.02 -969.28)",
    fill: "url(#radial-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18902",
    "data-name": "Path 18902",
    d: "M541.468,800.313c3.774,7.682,7.079,14.84,10.214,21.984a2.816,2.816,0,0,1-1.459,3.161c-1.53.641-3.446.017-3.843-1.215-2.039-6.915-4.62-14.6-7.15-23.005-.384-.882,1.853-1.806,2.237-.924Z",
    transform: "translate(-539.186 -799.957)",
    fill: "url(#radial-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18903",
    "data-name": "Path 18903",
    d: "M550.534,835.012l-.309.087a4.012,4.012,0,0,1-.887.086,3.358,3.358,0,0,1-1.317-.3,2.005,2.005,0,0,1-1.108-1.154c-.346-1.292-.727-2.813-1.206-4.416s-1-3.311-1.518-5.02l-1.634-4.98c-.516-1.591-1.058-3.056-1.487-4.325s-.836-2.309-1.095-3.047-.432-1.151-.432-1.151l1.3,4.265,2.95,9.36c1.08,3.4,2.139,6.81,2.9,9.377a2.128,2.128,0,0,0,1.272,1.23,3.481,3.481,0,0,0,1.377.242,3.742,3.742,0,0,0,.892-.145l.3-.109Z",
    transform: "translate(-539.498 -809.51)",
    fill: "url(#radial-gradient-47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8864",
    "data-name": "Group 8864",
    transform: "translate(2.671 3.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18904",
    "data-name": "Path 18904",
    d: "M561.8,827.68s2,4.932,3.843,9.919c.917,2.5,1.791,5.005,2.413,6.9s1.012,3.16,1.012,3.16a.414.414,0,0,0,.791-.241s0-.014-.006-.019-.442-1.259-1.149-3.128-1.686-4.347-2.707-6.805c-2.023-4.925-4.2-9.781-4.2-9.781Z",
    transform: "translate(-561.8 -827.68)",
    fill: "url(#radial-gradient-48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8865",
    "data-name": "Group 8865",
    transform: "translate(6.847 27.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18905",
    "data-name": "Path 18905",
    d: "M599.832,1035.19s-.49,3.646-1.092,7.27c-.311,1.81-.661,3.611-.978,4.944-.156.667-.3,1.215-.412,1.6l-.178.6,0,.011a.414.414,0,0,0,.793.237.152.152,0,0,0,.006-.025l.147-.626c.086-.4.2-.969.32-1.652.239-1.369.481-3.2.681-5.027.414-3.658.715-7.324.715-7.324Z",
    transform: "translate(-597.15 -1035.19)",
    fill: "url(#radial-gradient-49)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8866",
    "data-name": "Group 8866",
    transform: "translate(7.85 48.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18906",
    "data-name": "Path 18906",
    d: "M607.541,1217.7s.017-.152.033-.419.037-.648.027-1.106a18.938,18.938,0,0,0-.345-3.336,17.424,17.424,0,0,0-.953-3.219,12.8,12.8,0,0,0-.663-1.375s.03.151.093.409.148.626.253,1.069c.21.88.472,2.051.7,3.228s.43,2.361.584,3.254c.08.448.147.821.194,1.082s.081.412.081.412Z",
    transform: "translate(-605.64 -1208.25)",
    fill: "url(#radial-gradient-50)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8875",
    "data-name": "Group 8875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8869",
    "data-name": "Group 8869",
    transform: "translate(0.154 40.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18907",
    "data-name": "Path 18907",
    d: "M343.434,1145.12c-1.8-.475-6.274.948-7.66,6.93-1.273,5.5-.8,12.84,1.094,13.132s4.545-5.629,6.566-10.87C345.187,1149.766,345.231,1145.594,343.434,1145.12Z",
    transform: "translate(-335.06 -1145.035)",
    fill: "url(#radial-gradient-51)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8868",
    "data-name": "Group 8868",
    transform: "translate(1.438 7.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18908",
    "data-name": "Path 18908",
    d: "M348.554,1206.261s-.069.136-.175.378-.256.593-.395,1.025a15.038,15.038,0,0,0-.678,3.261,16.038,16.038,0,0,0,.034,3.33c.051.451.126.823.174,1.083s.09.406.09.406.013-.152.022-.416.031-.639.046-1.087c.036-.9.1-2.083.213-3.261s.278-2.353.424-3.238.243-1.484.243-1.484Z",
    transform: "translate(-347.237 -1206.26)",
    fill: "url(#radial-gradient-52)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8874",
    "data-name": "Group 8874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8871",
    "data-name": "Group 8871",
    transform: "translate(1.058 22.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18909",
    "data-name": "Path 18909",
    d: "M344.565,1007.3c.119.908,1.614,1.562,2.991,1.386,1.4-.177,2.674-1.2,2.554-2.116-1.641-5.828-2.84-12.364-4.28-19.334-.137-1.162-3.25-.579-3.113.584.4,7.289,1.206,13.7,1.849,19.479Z",
    transform: "translate(-342.713 -986.603)",
    fill: "url(#radial-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18910",
    "data-name": "Path 18910",
    d: "M373.371,1011.285s-.047-.308-.149-.842-.23-1.3-.417-2.207-.368-1.976-.608-3.109-.475-2.347-.719-3.559c-.268-1.207-.535-2.415-.787-3.547s-.535-2.18-.752-3.084-.455-1.644-.6-2.169-.25-.817-.25-.817l1.982,9.7c.509,2.423,1.054,4.839,1.507,6.639s.79,2.992.79,2.992Z",
    transform: "translate(-365.974 -991.318)",
    fill: "url(#radial-gradient-54)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8870",
    "data-name": "Group 8870",
    transform: "translate(1.195 6.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18911",
    "data-name": "Path 18911",
    d: "M352.831,1038.28s.256,3.665.658,7.324c.192,1.831.437,3.659.673,5.026s.457,2.275.457,2.275l0,.008a.414.414,0,0,0,.8-.2l-.007-.025s-.272-.864-.582-2.2-.669-3.13-.971-4.941-.552-3.629-.736-5-.3-2.277-.3-2.277Z",
    transform: "translate(-352.83 -1038.28)",
    fill: "url(#radial-gradient-55)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8873",
    "data-name": "Group 8873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18912",
    "data-name": "Path 18912",
    d: "M344.06,800.313c-3.774,7.682-7.079,14.84-10.214,21.984a2.817,2.817,0,0,0,1.459,3.161c1.53.641,3.446.017,3.843-1.215,2.039-6.915,4.62-14.6,7.15-23.005.384-.882-1.853-1.806-2.237-.924Z",
    transform: "translate(-333.757 -799.957)",
    fill: "url(#radial-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18913",
    "data-name": "Path 18913",
    d: "M346.861,835.02l.3.109a3.682,3.682,0,0,0,.892.145,3.485,3.485,0,0,0,1.377-.242,2.13,2.13,0,0,0,1.272-1.23c.756-2.568,1.816-5.976,2.9-9.377l2.95-9.36c.783-2.56,1.3-4.266,1.3-4.266s-.164.416-.432,1.15-.664,1.779-1.1,3.047-.97,2.733-1.487,4.325-1.077,3.285-1.634,4.98c-.516,1.709-1.034,3.417-1.517,5.02s-.86,3.123-1.206,4.415a2,2,0,0,1-1.108,1.154,3.356,3.356,0,0,1-1.317.3,4.065,4.065,0,0,1-.887-.086l-.31-.088Z",
    transform: "translate(-345.312 -809.519)",
    fill: "url(#radial-gradient-57)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8872",
    "data-name": "Group 8872",
    transform: "translate(1.471 2.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18914",
    "data-name": "Path 18914",
    d: "M354.759,824.271l-4.342,9.693c-1.082,2.425-2.153,4.855-2.935,6.69-.391.918-.708,1.688-.924,2.233s-.327.872-.327.872a.414.414,0,0,0,.78.276s0-.009,0-.014l0-.012s.094-.307.279-.849.471-1.321.822-2.25c.7-1.86,1.668-4.331,2.647-6.8l3.993-9.84Z",
    transform: "translate(-346.207 -824.27)",
    fill: "url(#radial-gradient-58)"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationBee);
export default __webpack_public_path__ + "static/media/Confirmation Bee.c5c24d4be7cca4b737e17a86b59d9651.svg";
export { ForwardRef as ReactComponent };